import { useEffect, useState } from "react";
import Modal from "react-modal/lib/components/Modal";
import api from "../../../services/api";
import logo from "../../../assets/logosz.png";
import "./style.css";
import closeImg from "../../../assets/close.png";
import { useRef } from "react";
import DetailsPayments from "../details-payments";
import CodeRealese from "./codeRelease";
import functions from "../../../util/functions";
import FormRegisterMinutoFood from "./form-minutofood";

Modal.setAppElement("#root");

function RegisterAuthModal(props) {
	const developmentVersion = [
		{ versao: "BETA" },
		{ versao: "A1" },
		{ versao: "A2" },
		{ versao: "A3" },
		{ versao: "A4" },
		{ versao: "A5" },
	];

	const [loading, setLoading] = useState(true);
	const [checkFields, setCheckFields] = useState(false);
	const [detailsPayments, setDetailsPayments] = useState(false);
	const [onFormMinutoFood, setOnFormMinutoFood] = useState(false);
	const [codeRelease, setcodeRelease] = useState(false);
	const [days, setDays] = useState(10);

	const [id_cliente, setID_Cliente] = useState(0);
	const [bd, setBd] = useState("");
	const [host, setHost] = useState("");
	const [port_0, setPort_0] = useState("");
	const [port_1, setPort_1] = useState("");
	const [id_auth, setID_Auth] = useState("");
	const [auth, setAuth] = useState("");
	const [carencia, setCarencia] = useState("");
	const [versao, setVersao] = useState("A1");
	const [status, setStatus] = useState("ATIVO");
	const [verificacoes, setVerificacoes] = useState(false);
	const [formInputs, setFormInputs] = useState([]);

	const inputDays = useRef();
	const footerDetails = useRef();

	const banco = functions.databaseConfig();

	useEffect(() => {
		if (props.isOpen) {
			const id = props.idCliente;
			setLoading(true);
			setCheckFields(false);
			setDetailsPayments(false);

			api.get(`v1/auth/contaentrada/auth`, {
				params: {
					id_cliente: id,
				},
				headers: {
					banco: banco,
				},
			})
				.then((response) => {
					if (response.status == 200) {
						setID_Cliente(response.data[0].id_cliente);
						setBd(response.data[0].bd);
						setHost(response.data[0].host);
						setPort_0(response.data[0].port_0);
						setPort_1(response.data[0].port_1);
						setID_Auth(response.data[0].id_auth);
						setAuth(response.data[0].auth);
						setStatus(response.data[0].status);
						setVersao(response.data[0].versao);
						setCarencia(response.data[0].carencia);

						// setSucesso("S");
						//setIsRegisterOpen(true);
					} else {
						// setSucesso("N");
					}
					setLoading(false);
				})
				.catch((err) => {
					setID_Cliente(id);
					setStatus(null);
					setBd("");
					setHost("");
					setPort_0("");
					setPort_1("");
					setID_Auth(0);
					setAuth("");

					// setSucesso("N");
					setLoading(false);
				});
		} else {
			setOnFormMinutoFood(false);
		}
	}, [props.isOpen]);

	useEffect(() => {
		if (detailsPayments) {
			footerDetails.current.scrollIntoView({ behavior: "smooth" });
		}
	}, [detailsPayments]);

	function close() {
		props.onRequestClose();
	}

	function verficarCampos() {
		let validate = true;
		let inputs = [...document.querySelectorAll("#floatingInput")];
		// setCheckFields(true);

		inputs.map((form, i) => {
			form.classList.remove("is-invalid");

			if (form.value.length == 0 && form.required) {
				form.classList.add("is-invalid");

				validate = false;
			}
		});

		return validate;
	}

	function registerAuth(e) {
		if (verficarCampos()) {
			api.post(`v1/auth/contaentrada/auth`, {
				bd,
				host,
				port_0,
				port_1,
				id_cliente,
				id_auth,
				auth,
				status,
				carencia,
				versao,
			})
				.then((response) => {
					props.listar();
					if (response.request.status == 200 || response.request.status == 201) {
						props.message("success");

						close();
					} else {
						props.message("error", `Erro ao salvar, ${response.request.response}`);
					}
				})
				.catch((err) => {
					if (err.response) {
						props.message("error", `Erro ao salvar, ${err.response.response}`);
					} else {
						props.message("error", "Verifique os dados e tente novamente");
						// setVerificacoes(false);
						close();
					}
				});
		}
	}

	function unlockTemporary() {
		inputDays.current.classList.remove("is-invalid");

		if (!days) {
			inputDays.current.classList.add("is-invalid");
			return;
		}

		api.post(`v1/auth/unlock`, {
			codauth: auth,
			days,
		})
			.then((response) => {
				if (response.request.status == 200 || response.request.status == 201) {
					props.message("success");
					close();
				} else {
					props.message("error", `Erro ao salvar, ${response.request.response}`);
				}
			})
			.catch((err) => {
				if (err.response) {
					props.message("error", `Erro ao salvar, ${err.response.response}`);
				} else {
					props.message("error", "Verifique os dados e tente novamente");
					// setVerificacoes(false);
					close();
				}
			});
	}

	function block() {
		api.post(`v1/auth/block`, {
			codauth: auth,
		})
			.then((response) => {
				if (response.request.status == 200 || response.request.status == 201) {
					props.message("success");
					close();
				} else {
					props.message("error", `Erro ao salvar, ${response.request.response}`);
				}
			})
			.catch((err) => {
				if (err.response) {
					props.message("error", `Erro ao salvar, ${err.response.response}`);
				} else {
					props.message("error", "Verifique os dados e tente novamente");
					// setVerificacoes(false);
					close();
				}
			});
	}

	function Details(isOpen) {
		//se for abrir verifica antes se tem numero de autenticação
		if ((isOpen && auth) || !isOpen) setDetailsPayments(isOpen);
	}

	function OpenFormMinutoFood(isOpen) {
		//se for abrir verifica antes se tem numero de autenticação
		if ((isOpen && auth) || !isOpen) setOnFormMinutoFood(isOpen);
	}

	function CloseFormMinutoFood() {
		//se for abrir verifica antes se tem numero de autenticação
		setOnFormMinutoFood(false);
	}

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.onRequestClose}
			overlayClassName="react-modal-overlay"
			className="react-modal-content"
		>
			<div className="logo-forms">
				<img className="logo-forms-img" src={logo} alt="" />
			</div>
			<button type="button" onClick={props.onRequestClose} className="react-modal-close">
				<img src={closeImg} alt="Fechar" />
			</button>

			<div className="container-fluid h-100 endereco">
				{!loading ? (
					<>
						<div className="col-12 mt-3 auth-content">
							<div className="d-flex justify-content-between">
								<h3>Cadastrar Autorização...</h3>
								<div>
									{status == "ATIVO" ? (
										<div className="badge_status bg_green">
											<small>Ativo</small>
										</div>
									) : null}
									{status == "BLOQUEIO" ? (
										<div className="badge_status badge_status bg_red">
											<small>Bloqueado</small>
										</div>
									) : null}
									{status == "B.TEMPORÁRIO" ? (
										<div className="badge_status badge_status bg_yellow">
											<small>B.Temporário</small>
										</div>
									) : null}
									{status == "ATRASADO" ? (
										<div className="badge_status badge_status bg_yellow">
											<small>Atrasado</small>
										</div>
									) : null}
									{status == null ? (
										<div className="badge_status badge_status bg_silver">
											<small>N.Autorizado</small>
										</div>
									) : null}
								</div>
							</div>
							<div className="d-flex justify-content-between align-itens-center mt-1">
								<div>
									<small className="text-secondary">Cliente</small>
									<h5>{props.nome}</h5>
								</div>
								<div>
									<small className="text-secondary">Autenticação</small>
									<h5>{auth}</h5>
								</div>
							</div>
						</div>
						<div className="row details-payments-content">
							{onFormMinutoFood ? (
								<FormRegisterMinutoFood CloseFormMinutoFood={CloseFormMinutoFood} codAuth={auth} />
							) : (
								<>
									<div className="form-floating mb-3 mt-3">
										<input
											type="text"
											value={bd}
											onChange={(e) => {
												setBd(e.target.value);
											}}
											className="form-control inp"
											id="floatingInput"
											placeholder=""
											required
										/>
										<label htmlFor="floatingInput">Banco de dados</label>
										<div className="valid-feedback">Validado!</div>
										<div className="invalid-feedback">
											Por favor digite o nome do banco de dados
										</div>
									</div>
									<div className="form-floating mb-3">
										<input
											type="text"
											value={host}
											onChange={(e) => {
												setHost(e.target.value);
											}}
											className="form-control inp"
											id="floatingInput"
											placeholder="api.szsistemas.com.br"
											required
										/>
										<label htmlFor="floatingInput">Host</label>
										<div className="valid-feedback">Validado!</div>
										<div className="invalid-feedback">Por favor digite o nome do servidor</div>
									</div>
									<div className="form-floating mb-3">
										<input
											type="text"
											value={carencia}
											onChange={(e) => {
												setCarencia(e.target.value);
											}}
											className="form-control inp"
											id="floatingInput"
											placeholder="Prazo máximo antes do bloqueio"
											required
										/>
										<label htmlFor="floatingInput">Carência em Dias</label>
										<div className="valid-feedback">Validado!</div>
										<div className="invalid-feedback">Por favor digite a porta do servidor</div>
									</div>

									<div className="mb-3">
										<small className="text-secondary">Versão da Atualização da aplicação</small>
										<select
											name="versoes"
											id="cidades"
											className="form-select"
											onChange={(e) => setVersao(e.target.value)}
											value={versao}
											required
										>
											<option value="" disabled>
												Versão da Atualização
											</option>
											{developmentVersion.map((c, i) => (
												<option key={i} value={c.versao}>
													{c.versao}
												</option>
											))}
										</select>
										<div className="valid-feedback">Validado!</div>
										<div className="invalid-feedback">Por favor, escolha a forma de pagamento</div>
									</div>

									<div className="form-floating mb-3">
										<input
											type="text"
											value={port_0}
											onChange={(e) => {
												setPort_0(e.target.value);
											}}
											className="form-control inp"
											id="floatingInput"
											placeholder="11120"
											required
										/>
										<label htmlFor="floatingInput">Porta do Servidor VCL</label>
										<div className="valid-feedback">Validado!</div>
										<div className="invalid-feedback">Por favor digite a porta do servidor</div>
									</div>
									<div className="form-floating mb-3">
										<input
											type="text"
											value={port_1}
											onChange={(e) => {
												setPort_1(e.target.value);
											}}
											className="form-control inp"
											id="floatingInput"
											placeholder="11120"
											required
										/>
										<label htmlFor="floatingInput">Porta do Servidor Horse</label>
										<div className="valid-feedback">Validado!</div>
										<div className="invalid-feedback">Por favor digite a porta do servidor</div>
									</div>
									<div className="row mb-3">
										<div className="col-12 mt-3 d-flex justify-content-end align-items-center border-bottom-secondary">
											<button
												type="button mt-3"
												onClick={(e) => registerAuth()}
												className="btn btn-lg btn-outline-primary"
											>
												Salvar
											</button>
										</div>
									</div>
								</>
							)}
							{/* <AtivoItemRadio status={status} setStatus={setStatus} checkFields={checkFields} /> */}

							<div className="row mb-3">
								{/* <div className="col-12 mt-3 d-flex justify-content-end align-items-center border-bottom-secondary">
									<button type="button mt-3" onClick={(e) => registerAuth()} className="btn btn-lg btn-outline-primary">
										Salvar
									</button>
								</div> */}

								<div className="col-12 mt-3 d-flex justify-content-end align-items-center">
									<button
										type="button"
										className="btn btn-sm btn-outline-primary btnw"
										onClick={(e) => Details(!detailsPayments)}
									>
										Detalhes dos pagamentos
									</button>
								</div>

								<div className="border-bottom-secondary">
									{detailsPayments ? <DetailsPayments codAuth={auth} /> : null}
								</div>

								{status === "BLOQUEIO" ? (
									<div className="d-flex flex-column mt-3">
										<div className="form-floating mb-3 ">
											<input
												type="number"
												value={days}
												onChange={(e) => {
													setDays(e.target.value);
												}}
												className="form-control"
												id="floatingInput"
												placeholder="Dias a mais"
												ref={inputDays}
											/>
											<label htmlFor="floatingInput">Quantidade de dias</label>
										</div>
										<div className="d-flex justify-content-end border-bottom-secondary">
											<button
												type="button"
												onClick={(e) => unlockTemporary()}
												className="btn btn-sm btn-outline-warning"
											>
												Desbloqueio temporario
											</button>
										</div>
									</div>
								) : null}
								{status === "B.TEMPORÁRIO" ? (
									<div className="d-flex justify-content-end mt-3">
										<button
											type="button"
											onClick={(e) => block()}
											className="btn btn-sm btn-outline-danger btn-block btnw"
										>
											Bloqueio
										</button>
									</div>
								) : null}
								<div>
									<div className="border-bottom-secondary">
										<div className="col-12 mt-3 d-flex justify-content-end align-items-center ">
											<button
												type="button"
												className="btn btn-sm btn-outline-primary btnw"
												onClick={(e) => OpenFormMinutoFood(!onFormMinutoFood)}
											>
												Cadastro Minuto Food
											</button>
										</div>
									</div>

									<CodeRealese />

									<div ref={footerDetails}></div>
								</div>
							</div>
						</div>
					</>
				) : (
					<div className="loading text-center h-100 m-5">
						<div>
							<span className="spinner-grow spinner-grow-sm text-primary me-2" role="status"></span>
							<span className="text-primary">Buscando Dados...</span>
						</div>
					</div>
				)}
			</div>
		</Modal>
	);
}

export default RegisterAuthModal;
